import type { InputSnapshot } from '../input/Controls';

export interface ReplayFrame {
  dt: number;
  input: InputSnapshot;
}

export interface ReplayTape {
  mapId: string;
  spawnId: string;
  x: number;
  y: number;
  vx: number;
  vy: number;
  frames: ReplayFrame[];
}

class ReplayState {
  recording = false;
  playing = false;
  private playTape: ReplayTape | null = null;
  private draftMeta: Omit<ReplayTape, 'frames'> | null = null;
  private draft: ReplayFrame[] = [];
  private index = 0;

  beginRecord(meta: Omit<ReplayTape, 'frames'>): void {
    this.recording = true;
    this.playing = false;
    this.draft = [];
    this.draftMeta = meta;
  }

  push(dt: number, input: InputSnapshot): void {
    if (!this.recording) return;
    this.draft.push({ dt, input: { ...input } });
  }

  stopRecord(): ReplayTape | null {
    this.recording = false;
    if (!this.draftMeta) return null;
    this.playTape = { ...this.draftMeta, frames: this.draft };
    return this.playTape;
  }

  last(): ReplayTape | null {
    return this.playTape;
  }

  beginPlay(): ReplayTape | null {
    if (!this.playTape?.frames.length) return null;
    this.recording = false;
    this.playing = true;
    this.index = 0;
    return this.playTape;
  }

  /** 한 업데이트에 한 프레임. 끝나면 null */
  next(): InputSnapshot | null {
    if (!this.playing || !this.playTape) return null;
    const frame = this.playTape.frames[this.index];
    this.index += 1;
    if (this.index >= this.playTape.frames.length) this.playing = false;
    return frame.input;
  }

  download(): void {
    const tape = this.playTape;
    if (!tape) return;
    const blob = new Blob([JSON.stringify(tape)], { type: 'application/json' });
    const a = document.createElement('a');
    a.href = URL.createObjectURL(blob);
    a.download = `replay-${tape.mapId}.json`;
    a.click();
    URL.revokeObjectURL(a.href);
  }
}

export const replay = new ReplayState();
